import { Box } from '@hivebrite/design-system/Box';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

const ITEM_WIDTHS = [120, 80, 100];

const MenuSkeleton = () => (
  <Box alignItems="center" height="100%">
    {ITEM_WIDTHS.map((width, index) => (
      <Skeleton key={index} height="24px" width={`${width}px`} mr={5} />
    ))}
  </Box>
);

export default MenuSkeleton;
